import { Form, Input, Tag, Button, Space, Flex } from 'antd'
import { useState } from 'react'

interface Props {
  fieldName: string
}

export const StatusesFormInput = ({ fieldName }: Props) => {
  const [inputValue, setInputValue] = useState('')

  const form = Form.useFormInstance()
  const tags = Form.useWatch(fieldName, form) || []

  const addTag = () => {
    if (inputValue.trim() && !tags.includes(inputValue.trim())) {
      form.setFieldValue(fieldName, [...tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const removeTag = (tagToRemove: string) => {
    form.setFieldValue(
      fieldName,
      tags.filter((tag: string) => tag !== tagToRemove)
    )
  }

  return (
    <Flex vertical gap={15}>
      <Space wrap>
        {tags.map((tag: string) => (
          <Tag key={tag} color="blue" closable onClose={() => removeTag(tag)}>
            {tag}
          </Tag>
        ))}
      </Space>
      <Space.Compact className="w-full">
        <Input
          className="w-full"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onPressEnter={addTag}
          placeholder="Add status name"
        />
        <Button onClick={addTag} type="primary">
          Add
        </Button>
      </Space.Compact>
    </Flex>
  )
}
